<template>
    <div>
        <b-container>
            <b-row>
                <b-col>
                    <h5><span style="color:#2e5189"><font-awesome-icon icon="user" /> Company:</span> {{buyer.company}}</h5>
                    <hr>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <h5><span style="color:#2e5189"><font-awesome-icon icon="envelope" /> Email:</span> {{buyer.email}}</h5> 
                    <hr>
                </b-col>
            </b-row>
        
            <b-row v-if="buyer.phone">
                <b-col>
                    <h5><span style="color:#2e5189"><font-awesome-icon icon="phone" /> Phone:</span> {{buyer.phone}}</h5>
                    <hr>
                </b-col>
            </b-row>

            <b-row v-if="buyer.contactname">
                <b-col>
                    <h5><span style="color:#2e5189"><font-awesome-icon icon="user" /> Contact Name:</span> {{buyer.contactname}}</h5>
                    <hr>
                </b-col>
            </b-row>
            
            <b-row>
                <b-col>
                    <h5><span style="color:#2e5189"><font-awesome-icon icon="location-arrow" /> Address:</span></h5> {{buyer.address}}
                    <hr>
                </b-col>
            </b-row>
            <b-row v-if="buyer.deliveryInstructions">
                <b-col>
                    <h5><span style="color:#2e5189"><font-awesome-icon icon="info-circle" /> Delivery Instructions:</span></h5> <h6>{{buyer.deliveryInstructions}}</h6>
                </b-col>
            </b-row>
            <hr>
            <b-row v-if="buyer.abcLicenseNumber">
                <b-col>
                    <h5><span style="color:#2e5189"><font-awesome-icon icon="id-card" /> ABC License Number: </span>{{buyer.abcLicenseNumber}}</h5>
                </b-col>
            </b-row>

        </b-container>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import moment from 'moment'
    import { currentUser } from '../firebaseConfig'
    const fb = require('../firebaseConfig.js')
    import Sendmessage from './Sendmessage'
    import Pagefooter from './Pagefooter'

    export default {
        props: ['buyerId'],
        components: {
            Sendmessage,
            Pagefooter,
            },

        data() {
            return {
                buyerName:'',
                buyer:{},

            }
        },
        mounted(){
            console.log("Buyer ID = " + this.buyerId)
            this.getBuyerProfile()
        },

        methods: {
            getBuyerProfile(){
                this.loadingPage = true
                fb.usersCollection.doc(this.buyerId).get().then(res => {
                    this.buyer = res.data()
                    this.buyer.address = res.data().street1
                    
                    if (res.data().street2){
                        this.buyer.address  = this.buyer.address  + ' ' + res.data().street2
                    }
                    this.buyer.address  = this.buyer.address  + ', ' + res.data().city + ', ' + res.data().state + ', ' + res.data().zip
                    this.loadingPage=false

                    console.log("Buyer = ")
                    console.log(this.buyer)

            }).catch(err => {
                console.log(err)
            })


            },

        }

        
    }
</script>